<template>
  <div id="app">
    <div id="college" v-if="status=='college'||status.slice(0, 5)=='shops'">
      <el-container v-if="status=='college'">
        <!--        <div class="homepage">-->
        <!--          <el-row class=" class="homepage"">-->
        <!--            <el-col :xs="24" :sm="16" :md="17">-->
        <!--              <div class="hallo">您好,欢迎来到仪小星讲堂</div>-->
        <!--            </el-col>-->
        <!--            <el-col :xs="24" :sm="8" :md="7">-->
        <!--              <div class="user-log" style="margin-left: 18px">-->
        <!--                <span class="loginbar"> <a class="xuanzhong wenzi" href="user.html#index">{{ $store.state.information != '' ? '个人中心' : '请登录' }}</a></span>-->
        <!--                <el-divider direction="vertical" class="shuxian"></el-divider>-->
        <!--                <span class="regsiter"><a href="user.html#/" v-if="$store.state.information==''">免费注册</a></span>-->
        <!--              </div>-->
        <!--            </el-col>-->
        <!--          </el-row>-->
        <!--        </div>-->
        <headerall>
          <slot>
            <div style="display:inline;position:relative;">
              <el-row>
                <el-col :xs="24" :sm="16" :md="17">
                  <div class="hallo" style="position:absolute">您好!欢迎来到仪小星讲堂</div>
                </el-col>
              </el-row>
            </div>
          </slot>
        </headerall>
        <el-header class="college_page_important_qiangzhi_buxudong hidden-sm-and-down">
          <el-row class="head_page">
            <el-col :xs="24" :sm="8" :md="8">
              <a href="#/college">
                <img class="yixiaoxing_logo" src="./assets/home/yixiaoxingtoubu.png" alt="">
                <img class="yixiaoxing_title" src="./assets/home/yixiaoxing_title.png" alt="">
              </a>
            </el-col>
            <el-col :xs="24" :sm="16" :md="16">
              <div class="sousuo_block">
                <el-input size="small " placeholder="请输入内容" v-model="sousuo" class="input-with-select">
                  <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                    <el-option label="新手指南" value="#/college/novice"></el-option>
                    <el-option label="专项提升" value="#/college/promote"></el-option>
                    <el-option label="仪才秀" value="#/college/video"></el-option>
                    <el-option label="应用方案" value="#/college/programme"></el-option>
                    <el-option label="行业标准" value="#
                    /college/standard"></el-option>
                  </el-select>
                  <el-button class="input_button" slot="append" @click="shijian(sousuo)">搜索</el-button>
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="head_page">
            <el-col class="head_classify hidden-sm-and-down" :xs="24" :sm="3" :md="5" :lg="5">
              <div class="class_classify_border">
                <div class="class_classify">
                  <img src="./assets/home/shangpinfenlei.png" alt=""
                       style="margin-right: 12px">课程分类
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="22" :md="19" :lg="19" style="float: left; margin-top:60px;">
              <a class="head_click1" href="#/college">
                <div :style="$route.path.slice(0,14)=='/college'?
                  'font-size: 18px;font-weight: bold;color: #4E6EF2;':'font-size: 16px;'">全部
                </div>
              </a>
              <div v-for="(item,index) in list" :key="index">
                <a class="head_click1" :href="'#/college' + item.link">
                  <div :style="$route.path.slice(0,14)=='/college' + item.link?
                  'font-size: 18px;font-weight: bold;color: #4E6EF2;':'font-size: 16px;'">{{ item.name }}
                  </div>
                </a>
              </div>
              <a class="" :class="$route.path.slice(0,14)=='/college/video'?'head_click0':'head_click2'"
                 href="#/college/video" style="width:90px">
                <img style="float: left; margin-right: 3px; "
                     :style="$route.path.slice(0,14)=='/college/video'?'margin-top: 7px':'margin-top: 3px'"
                     src="./assets/home/shangjiarenzheng.png" alt="">
                <div>仪才秀</div>
              </a>
              <a class="" href="#/college/programme" style="width:100px"
                 :class="$route.path.slice(0,14)=='/college/progr'?'head_click0':'head_click2'"
                 :style="$route.path.slice(0,14)=='/college/progr'?'font-size: 18px;width:110px;':'font-size: 16px;width:100px;'">
                <img style="float: left; margin-right: 3px; "
                     :style="$route.path.slice(0,14)=='/college/progr'?'margin-top: 7px':'margin-top: 3px'"
                     src="./assets/home/shangjiarenzheng.png" alt="">
                <div>应用方案</div>
              </a>
              <a class="" href="#/college/standard" style=""
                 :class="$route.path.slice(0,14)=='/college/stand'?'head_click0':'head_click2'"
                 :style="$route.path.slice(0,14)=='/college/stand'?'font-size: 18px;width:140px;':'font-size: 16px;width:140px;'">
                <img style="float: left; margin-right: 3px;"
                     :style="$route.path.slice(0,14)=='/college/stand'?'margin-top: 7px':'margin-top: 3px'"
                     src="./assets/home/shangjiarenzheng.png" alt="">
                <div>国家行业标准</div>
              </a>
            </el-col>
            <el-divider class="hr hidden-sm-and-down"></el-divider>
          </el-row>
        </el-header>
        <router-view></router-view>
        <!--        <el-footer height="130px" :style="status_two!==''?'background: #ffffff;':'background: #333333;'">-->
        <!--          <div class="college_footer">-->
        <!--            <div class="footer_lanmu_one text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">© 2020-2021-->
        <!--              仪海仪家 版权所有-->
        <!--            </div>-->
        <!--            <div class="footer_lanmu_two text">-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">著作权与商标声明</span>-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">平台规则</span>-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">服务条款</span>-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">帮助中心</span>-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">关于仪海仪家</span>-->
        <!--              <span class="two_text" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">联系我们</span>-->
        <!--              <span class="two_text two_text2" :style="status_two!==''?'color:#000000;':'color:#ffffff;'">网站导航</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </el-footer>-->
        <footerall></footerall>
      </el-container>
      <el-container v-if="status.slice(0, 5)=='shops'">

        <el-header height="270px" class="shops-header hidden-sm-and-down">
          <shops_header></shops_header>
        </el-header>
        <el-header height="45px" class="shops-header hidden-sm-and-up">
          <shops_header></shops_header>
        </el-header>
        <template>
          <el-main style="background: #F9F9F9">
            <div>
              <shops_header_class></shops_header_class>
            </div>
            <shops_nav></shops_nav>
            <router-view></router-view>
          </el-main>
        </template>
        <template>
        </template>
        <footerall></footerall>
      </el-container>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
    import shops_header from './components/home/shops/common/header'
    import shops_header_class from './components/home/shops/common/classification'
    import shops_nav from './components/home/shops/common/nav.vue'
    import headerall from './components/common/head'
    // import Home_head from './components/common/home-head'
    import footerall from "./components/common/footer";

    export default {
        name: 'App',
        components: {
            shops_nav,
            shops_header,
            shops_header_class,
            headerall,
            footerall,
            // home_head
        },
        data() {
            return {
                input: '',
                input1: '',
                sousuo: '',
                url: '',
                status: '',
                status_two: '',
                information: '',
                select: '#/college/novice',
                id: '',
                data_info: '',
                // information,
                list: [],
                auth_list:[],
                weidu:[],
                total_xi: 0,
                uid_liss:''
            }
        },
        methods: {
            init() {
                this.information = this.$store.state.information
                // this.id = this.$route.params
                this.status = this.$route.path.slice(1, 8)

                // console.log(this.status,'this.status')
                this.status_two = this.$route.path.slice(9, 12)
                // console.log(this.$route.path.slice(1,5),99999999999)
                var t = this;
                t.url = window.config.api_url;
                t.InformationEevent()
                t.get_list()
                t.get_uidlist();
            },
            //聊天室 消息数
            get_chatlist(){
              let t = this;
              if (document.location.protocol == 'http:'){
                let url = 'http://ws.yi-mix.com/chat/room?uid=' + this.uid_liss;
                t.axios.get(url).then(res=>{
                  t.auth_list = res.data
                  this.weidu = [];
                  this.total_xi = 0;
                  for (let i = 0;i<t.auth_list.length;i++){
                    t.weidu.push(JSON.parse(t.auth_list[i].unread_total));
                  }
                  t.weidu.forEach(item=>{
                    t.total_xi += item;
                  })
                  t.$store.commit('set_total_unread',t.total_xi);
                })
              }else {
                let url1 = 'https://ws.yi-mix.com/chat/room?uid=' + this.uid_liss;
                t.axios.get(url1).then(res=>{
                  t.auth_list = res.data
                  this.weidu = [];
                  this.total_xi = 0;
                  for (let i = 0;i<t.auth_list.length;i++){
                    t.weidu.push(JSON.parse(t.auth_list[i].unread_total));
                  }
                  t.weidu.forEach(item=>{
                    t.total_xi += item;
                  })
                  t.$store.commit('set_total_unread',t.total_xi);
                })
              }
            },
            get_uidlist(){
              var t = this;
              var aid = localStorage.getItem('uid');
              var url = window.config.api_url + '/user/info?token=' + aid;
              t.axios.get(url).then(res=>{
                t.uid_liss = res.data.wechat_info.uid
                this.get_chatlist()
              })
            },
            shijian(a) {
                var t = this
                t.sousuo = a
                if (t.sousuo) {
                    t.$store.commit('categorySearchValue', t.sousuo)
                }
                window.location = t.select
                if (this.$route.path == '/college/programme') {
                    t.fangan_list()
                }
                if (this.$route.path == '/college/standard') {
                    // t.anniuzhuangtai = 2
                    t.biaozhun_list()
                }
                if (this.$route.path == '/college/video') {
                    // t.anniuzhuangtai = 2
                    t.yicaixiu_list()
                }
                if (this.$route.path == '/college/promote') {
                    // t.anniuzhuangtai = 2
                    t.zhuanxiang_list()
                }
                if (this.$route.path == '/college/novice') {
                    // t.anniuzhuangtai = 2
                    t.xinshou_list()
                }
            },
            fangan_list() {
                var t = this
                var url = window.config.api_url + '/college/application'
                if (t.sousuo) {
                    url += '&keywords=' + t.sousuo
                }
                t.axios.get(url).then(res => {
                    t.applicationzhi = res.data.list.data
                    t.yemashu = res.data.list.last_page
                    t.zongshu = res.data.list.total
                })
            },
            biaozhun_list() {
                var t = this
                var url = window.config.api_url + '/college/norm'
                if (t.sousuo) {
                    url += '&keywords=' + t.sousuo
                }
                t.axios.get(url).then(res => {
                    t.normzhi = res.data.list.data
                    t.yemashu = res.data.list.last_page
                    t.zongshu = res.data.list.total
                })
            },
            yicaixiu_list() {
                var t = this
                var url = window.config.api_url + '/college/video?paginate=20'
                if (t.sousuo) {
                    url += '&keywords=' + t.sousuo
                }
                t.axios.get(url).then(res => {
                    t.lightzhi = res.data.list
                    t.yemashu = res.data.list.last_page
                    t.zongshu = res.data.list.total
                    console.log(t.lightzhi)
                })
            },
            zhuanxiang_list() {
                var t = this
                var url = window.config.api_url + '/college/article/search?cat_id=63'
                if (t.sousuo) {
                    url += '&title=' + t.sousuo
                }
                if (t.leixingzhi) {
                    url += '&type=' + t.leixingzhi
                }
                t.axios.get(url).then(res => {
                    t.lightzhi = res.data.list
                    t.yemashu = res.data.list.last_page
                    t.zongshu = res.data.list.total
                })
            },
            xinshou_list() {
                var t = this
                var url = window.config.api_url + '/college/article/search?cat_id=62'
                if (t.sousuo) {
                    url += '&title=' + t.sousuo
                }
                if (t.leixingzhi) {
                    url += '&type=' + t.leixingzhi
                }
                t.axios.get(url).then(res => {
                    t.lightzhi = res.data.list
                    t.yemashu = res.data.list.last_page
                    t.zongshu = res.data.list.total
                })
            },
            InformationEevent() {
                var t = this
                if (this.$store.state.information !== '') {
                    return 't.url';
                }
                var id = localStorage.getItem("uid")
                t.axios.get(t.url + '/user/info?token=' + id).then(res => {
                    if (res.data.status !== 101) {
                        t.$store.commit('information_event', res.data)
                    }
                })
            },
            get_list() {
                var t = this;
                var url = window.config.api_url + '/college/nav/?pid=' + 1;
                this.axios.get(url).then((res) => {
                    t.list = res.data
                })
            }
        },
        created() {
            this.init()
        },
        watch: {
            '$route'() {
                if (this.$route.params.id) {
                    this.init()
                } else {
                    this.init()
                }
                // 路由发生变化页面刷新
            }
        },
    }
</script>
<style>
  .college_page_important_qiangzhi_buxudong .el-input-group--append .el-input__inner, .el-input-group__prepend {
    height: 45px !important;
    border: 2px solid #C6241D;
  }

  /*.college_page_important_qiangzhi_buxudong .el-input__inner {*/
  /*  position: absolute;*/
  /*  width: 503px !important;*/
  /*  height: 45px !important;*/
  /*  border: 2px solid #C6241D !important;*/
  /*  border-radius: 5px 0px 0px 5px !important;*/
  /*  padding: 0 35px !important;*/
  /*}*/

</style>
<style lang="less" scoped>
  @import "./../node_modules/element-ui/lib/theme-chalk/display.css";

  //@head_text: Source Han Sans CN;
  @font-face {
    //font-family: 'Source Han Sans CN';
    //src: url('./assets/home/SourceHanSansCN-Normal.ttf');
  }

  //@import "./assets/css/home";
  @import "./assets/css/home_college";

  .hallo {
    font-family: Source Han Sans CN;
    font-size: 15px;
    margin-top: 8px;
  }
</style>
<style lang="less" scoped>
  @font-face {
    //font-family: 'Source Han Sans CN';
    //src: url('./assets/home/SourceHanSansCN-Normal.ttf');
  }

  .college_main {
    background-color: #F4F4F4;
    height: 445px;

    .main_top {
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;
      height: 420px;

      .top_lunbo {
        width: 98%;
        height: 98%;
        margin-left: 1%;
        margin-top: 1%;
      }

      .top_xinxi {
        height: 420px;
        width: 100%;
        float: left;

        .xinxi_kuang {
          height: 97%;
          margin-top: 3%;
          background: #FFFFFF;
          //display:table-cell;
          text-align: center;

          .kuang_img {
            width: 95px;
            height: 95px;
            margin-top: 55px;
            margin-bottom: 40px;
          }

          .kuang_butt {
            text-align: center;
            width: 160px;
            height: 40px;
            background: #C6241D;
            margin: 0 auto;
            border-radius: 5px;

            .butt_text {
              line-height: 40px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #FFFFFF;
            }
          }

          .kuang_text {
            text-align: center;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            line-height: 100px;
          }
        }
      }

      .top_fenlei {
        background: #FFFFFF;
        height: 420px;

        .fenlei_xuanxiang {
          width: 100%;
          height: 104px;
          float: left;

          .bt_neirong {
            margin-top: 15px;
            margin-left: 18px;
          }

          .nr_neirong {
            float: left;
            margin-top: 10px;
            margin-left: 18px;
            padding-right: 10px;
            border-right: 1px solid;
          }

          .text_bt {
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }

          .text_nr {
            font-size: 10px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }

  .ditu_bt {
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .bt_text {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 80px;
      margin-right: 12px;
    }

    .bt_texts {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #777777;
      line-height: 80px;
    }
  }

  .ditu {
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .ditu_img {
      //float: left;
      height: 190px;
      text-align: center;
      background-image: url("./assets/home/college/cT3mZ1MYQ680qLrOXCUFF9qDXioLVowouBJdOvFj.png");

      .img_text {
        padding-top: 120px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
      }

      .img_texts {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        //line-height: 100px;
      }
    }
  }

  .zhinan {
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .zhinan_img {
      height: 236px;
      background-image: url("./assets/home/college/TB1LiNiObrpK1RjSZTEXXcWAVXa-285-290.png");

      .img_biaoqian {
        float: left;
        margin-top: 28px;
        width: 68px;
        height: 20px;
        background: #C6241D;
        border-radius: 3px;
        text-align: center;

        .biaoqian_text {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
        }
      }

      .img_flot {
        width: 88%;
        margin-left: 6%;

        .flot_biaoti {
          width: 100%;
          float: left;
          margin-top: 20px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          //line-height: 100px;
        }

        .flot_shijian {
          float: left;
          margin-top: 20px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }

        .flot_img {
          width: 100%;
          float: left;
          margin-top: 15px;
        }

        .flot_lamu {
          float: left;
          margin-top: 15px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          //line-height: 100px;
          width: 100%;
        }
      }
    }
  }

  .el-footer {
    background: #333333;
  }

  .college_footer {
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    //height: 320px;
    .footer_lanmu_one {
      margin-top: 30px;
    }

    .footer_lanmu_two {
      margin-top: 34px;

      .two_text {
        padding-right: 8px;
        padding-left: 8px;
        border-right: 1px solid #FFFFFF;
      }

      .two_text2 {
        border-right: none;
      }
    }

    .text {
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }

  }

  .el-main {
    padding: 0;
  }

  .shops-footer {
    background: #FFFFFF;
    padding: 0;
  }

  .shops-